export default __webpack_public_path__ + "static/media/browser_not_supported.a3b05a77.png";